import React from 'react';
import { Box, Container, Divider, useColorModeValue, VStack } from '@chakra-ui/react';
import { motion, useAnimation, useInView } from 'framer-motion';
import NavBarv3 from './navbarv3';
import Footer from './footer';
import Journey from './journey';
import Hero from './hero';
import FeaturedProjects from './projects';

const MotionBox = motion(Box);
const MotionContainer = motion(Container);

const fadeInUpVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.6, -0.05, 0.01, 0.99] }
  }
};

const staggerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.3 }
  }
};

function AnimatedSection({ children }) {
  const controls = useAnimation();
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });

  React.useEffect(() => {
    if (isInView) {
      controls.start('visible');
    }
  }, [controls, isInView]);

  return (
    <MotionBox
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={staggerVariants}
    >
      {children}
    </MotionBox>
  );
}

export default function Homev3() {
  const bgColor = useColorModeValue('white', 'black');
  const textColor = useColorModeValue('gray.900', 'gray.100');
  const secondaryTextColor = useColorModeValue('gray.600', 'gray.400');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const accentColor = useColorModeValue('blue.500', 'blue.300');

  return (
    <MotionBox
      bg={bgColor}
      color={textColor}
      minHeight="100vh"
      initial="hidden"
      animate="visible"
      variants={fadeInUpVariants}
    >
      <NavBarv3 />
      <MotionContainer maxW="container.xl" px={4} variants={staggerVariants}>
        <VStack spacing={20} align="stretch">
          <AnimatedSection>
            <Hero
              textColor={textColor}
              secondaryTextColor={secondaryTextColor}
              accentColor={accentColor}
            />
          </AnimatedSection>
          <Divider />
          <AnimatedSection>
            <FeaturedProjects
              borderColor={borderColor}
              secondaryTextColor={secondaryTextColor}
              accentColor={accentColor}
            />
          </AnimatedSection>
          <Divider />
          <AnimatedSection>
            <Journey
              textColor={textColor}
              secondaryTextColor={secondaryTextColor}
              accentColor={accentColor}
            />
          </AnimatedSection>
        </VStack>
      </MotionContainer>
      <Footer />
    </MotionBox>
  );
}
